import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import jsonData from './pressureData.json'
import { LabelType } from '@angular-slider/ngx-slider';
import { HttpClient } from '@angular/common/http';
import * as simpleheat from 'simpleheat';
import Swal from 'sweetalert2';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { SharedModule } from 'src/app/layouts/full/shared/shared.module';

@Component({
  selector: 'app-pressure-map',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './pressure-map.component.html',
  styleUrl: './pressure-map.component.scss'
})
export class PressureMapComponent {

  @Input() jsonUrl;
  @Input() orderData;
  @Input() jsonData;
  @Input() foot;
  @Input() rotate180;
  @Input() showActions: boolean = false
  @Input() width = 450;
  @Input() pointsToDraw: { x: number, y: number }[] = [];
  @Input() generatingPDF: boolean

  loadingJson: boolean = false;
  @Input() isStatic: boolean = false;
  @Input() isBalance: boolean = false
  time = 0;
  foundAlonePoints = false;
  rotated = false;
  minValues: { x: number, y: number };
  radius
  blur
  platformNumberOfSensors = 48;
  // Points to move to center the results
  pointsToMoveX;
  pointsToMoveY;

  // heatmap
  @ViewChild("myCanvas") myCanvas: ElementRef = {} as ElementRef;

  pressuresRecord = jsonData
  gradientCfg = {
    0.05: '#0000ff', // green
    0.1: '#0060ff',
    0.15: '#0090cc',
    0.20: '#6060ff',
    0.25: '#aaaaff',
    0.30: '#55c5aa',
    0.35: '#00c010',
    0.40: '#00d020',
    0.45: '#55e755',
    0.50: '#01ff00',
    0.55: '#aaffaa',
    0.60: '#d4ff55',
    0.65: '#ffff00',
    0.75: '#ffff00',
    0.80: '#ffd400',
    0.85: '#ff6500',
    0.90: '#dd4000',
    0.95: '#ff0000',
  };

  heatmapInstance;
  heat;

  sliderOption = {
    value: 0,
    options: {
      floor: 0,
      ceil: 0,
      disabled: false,

      translate: (value: number, label: LabelType): string => {
        switch (label) {
          case LabelType.Low:
            return '<b>record</b> ' + value;
          case LabelType.High:
            return '<b>record</b> ' + value;
          default:
            return `${value}`;
        }
      },
    }
  };

  // Player
  playing: boolean = false;

  sliderFramesPerSecond = {
    value: 30,
    options: {
      floor: 1,
      ceil: 30,
      disabled: false,

      translate: (value: number, label: LabelType): string => {
        switch (label) {
          case LabelType.Low:
            return '<b>FPS</b> ' + value;
          case LabelType.High:
            return '<b>FPS</b> ' + value;
          default:
            return `${value}`;
        }
      },
    }
  };

  sizeOfPressure: { width: number, height: number };


  constructor(
    private http: HttpClient
  ) {

  }

  ngOnInit(): void {
    if (this.jsonUrl) {
      this.readJson();
    }
  }

  ngAfterViewInit(): void {

    this.setupCanvasWidthAndRadius();
    // this.heatmapInstance = h337.create({
    //   container: this.map.nativeElement,
    //   gradient: this.gradientCfg,
    //   radius: 10,
    // });

    // new heatmap
    let canvas = this.myCanvas.nativeElement;
    this.heat = simpleheat(canvas);

    if (jsonData) {
      this.showAllPoints();
      this.setSliderConfiguration();
    }

    // if (this.showActions) {
    //   this.drawPoints();
    // }

  }

  centerPoints() {
    let minMaxValues = {
      x: {
        min: Number.MAX_VALUE,
        max: Number.MIN_VALUE
      },
      y: {
        min: Number.MAX_VALUE,
        max: Number.MIN_VALUE
      }
    };

    // Calcular los valores mínimos y máximos para x y y
    this.jsonData.forEach((record: { time: number, pressures: { x: number, y: number, weight: number }[] }) => {
      record.pressures.forEach((point) => {
        if (point.x < minMaxValues.x.min) {
          minMaxValues.x.min = point.x;
        }

        if (point.x > minMaxValues.x.max) {
          minMaxValues.x.max = point.x;
        }

        if (point.y < minMaxValues.y.min) {
          minMaxValues.y.min = point.y;
        }

        if (point.y > minMaxValues.y.max) {
          minMaxValues.y.max = point.y;
        }
      });
    });

    // Obtener el punto medio de la plataforma
    let halfPointOfThePlatform = this.platformNumberOfSensors / 2;

    // Calcular los puntos centrales del cuadro delimitador
    let centerX = (minMaxValues.x.min + minMaxValues.x.max) / 2;
    let centerY = (minMaxValues.y.min + minMaxValues.y.max) / 2;

    // Calcular cuánto necesitamos mover los puntos para centrarlos
    let offsetX = halfPointOfThePlatform - centerX;
    let offsetY = halfPointOfThePlatform - centerY;

    // Mover los puntos
    this.jsonData.forEach((record) => {
      record.pressures.forEach((point) => {
        point.x += offsetX;
        point.y += offsetY;
      });
    });
  }

  drawPoints() {
    // Draw line
    const ctx = this.myCanvas.nativeElement.getContext('2d');

    this.pointsToDraw.map((point) => {
      // Depending on the width we have to know th value to mulitply the point to get in the right place
      let valueToMultiply = this.width / this.platformNumberOfSensors;

      let x = point.x * valueToMultiply;
      let y = point.y * valueToMultiply;


      x += this.pointsToMoveX > 0 ? this.pointsToMoveX * valueToMultiply : 0;
      y += this.pointsToMoveY > 0 ? this.pointsToMoveY * valueToMultiply : 0;


      x -= this.pointsToMoveX < 0 ? Math.abs(this.pointsToMoveX) * valueToMultiply : 0;
      y -= this.pointsToMoveY < 0 ? Math.abs(this.pointsToMoveY) * valueToMultiply : 0;

      // draw a red line
      ctx.beginPath();
      // ctx.fillRect(COP.x, COP.y, 10, 10);
      ctx.globalAlpha = 1.0;
      ctx.arc(x, y, 5, 0, 2 * Math.PI, false);
      ctx.fillStyle = 'white';
      ctx.fill();
      ctx.lineWidth = 3;
      ctx.strokeStyle = '#003300';
      ctx.stroke();

    })

  }

  setupCanvasWidthAndRadius() {
    this.minValues = {
      x: this.width,
      y: this.width
    }

    this.sizeOfPressure = {
      height: this.width,
      width: this.width
    }

    this.radius = this.width * 0.025;
    this.blur = this.radius / 2;
  }

  changeDisableOptions() {
    this.sliderFramesPerSecond.options = Object.assign({}, this.sliderFramesPerSecond.options, { disabled: !this.sliderFramesPerSecond.options.disabled });
    this.sliderOption.options = Object.assign({}, this.sliderOption.options, { disabled: !this.sliderOption.options.disabled });
  }

  readJson() {
    this.loadingJson = true;

    this.http.get(this.jsonUrl).subscribe((jsonData) => {
      this.jsonData = jsonData;

      // Filter data from JSON

      this.loadingJson = false;

      if (this.jsonUrl.includes('static')) {
        this.isStatic = true;
      }

      if (this.jsonUrl.includes('left_')) {
        this.foot = 'left';
      }

      if (this.jsonUrl.includes('right_')) {
        this.foot = 'right';
      }



      this.setSliderConfiguration();
      this.showAllPoints();
    }, (err) => {
      Swal.fire("ERROR LOADING", "Error loading url", "error")
      this.loadingJson = false;
    })
  }

  removeSinglePoints(points: { x: number, y: number, value: number }[]) {

    points.map((point, index) => {

      // Distance between each point
      // width of pressure / Number of sensors
      let eachPointDistance = this.sizeOfPressure.width / this.platformNumberOfSensors;

      // Check if has some point without neightbor
      // When remove a point
      //  0 | 0 | 0
      //  0 | 1 | 0
      //  0 | 0 | 0

      let point1 = points.find((pointToFind) => pointToFind.x === point.x - eachPointDistance && pointToFind.y === point.y)
      let point2 = points.find((pointToFind) => pointToFind.x === point.x - eachPointDistance && pointToFind.y === point.y + eachPointDistance)
      let point3 = points.find((pointToFind) => pointToFind.x === point.x && pointToFind.y === point.y + eachPointDistance)
      let point4 = points.find((pointToFind) => pointToFind.x === point.x + eachPointDistance && pointToFind.y === point.y + eachPointDistance)
      let point5 = points.find((pointToFind) => pointToFind.x === point.x + eachPointDistance && pointToFind.y === point.y)
      let point6 = points.find((pointToFind) => pointToFind.x === point.x + eachPointDistance && pointToFind.y === point.y - eachPointDistance)
      let point7 = points.find((pointToFind) => pointToFind.x === point.x && pointToFind.y === point.y - eachPointDistance)
      let point8 = points.find((pointToFind) => pointToFind.x === point.x - eachPointDistance && pointToFind.y === point.y - eachPointDistance)

      if (!point1 && !point2 && !point3 && !point4 && !point5 && !point6 && !point7 && !point8) {
        points.splice(index, 1)
      }

    })

    return points;
  }

  setSliderConfiguration() {

    this.sliderOption = {
      value: 0,
      options: {
        floor: 0,
        ceil: this.jsonData.length,
        disabled: false,

        translate: (value: number, label: LabelType): string => {
          switch (label) {
            case LabelType.Low:
              return '<b>record</b> ' + value;
            case LabelType.High:
              return '<b>record</b> ' + value;
            default:
              return `${value}`;
          }
        },
      }
    }
  }


  showPressure(pressureIndex) {

    var width = this.sizeOfPressure.width;
    var height = this.sizeOfPressure.height;
    var newPoints = [];

    var points: { x: number, y: number, value: number }[] = [];
    let max = 0;

    this.jsonData[pressureIndex].pressures.map((record) => {
      let weight = record.weight
      let x = (record.x * (width / this.platformNumberOfSensors));
      let y = (record.y * (height / this.platformNumberOfSensors));

      if (weight > max) {
        max = weight;
      }
      // check if already exists and it higher
      let existsPoint = points.find((value) => value.x === x && value.y === y);

      if (!existsPoint) {
        points.push({
          x,
          y,
          value: weight
        })
      }

    })

    // remove alone points without other points arround
    points = this.removeSinglePoints(points);


    points.map((point) => {
      if (point.x < this.minValues.x) {
        this.minValues.x = point.x;
      }

      if (point.y < this.minValues.y) {
        this.minValues.y = point.y;
      }

      newPoints.push([point.x, point.y, point.value])
    })




    // Draw line
    const ctx = this.myCanvas.nativeElement.getContext('2d');

    // set line stroke and line width
    ctx.strokeStyle = 'red';
    ctx.lineWidth = 10;

    // Get center of pressure
    let COP = this.centerOfPressure(points);


    // var data = {
    //   max,
    //   min: 0,
    //   data: points
    // };

    // this.heatmapInstance.setData(data);


    this.heat.clear()
    this.heat.data(newPoints)
    this.heat.radius(this.radius, this.blur)
    this.heat.max(max + 40)
    this.heat.draw()

    // draw a red line
    ctx.beginPath();
    // ctx.fillRect(COP.x, COP.y, 10, 10);
    ctx.globalAlpha = 1.0;
    ctx.arc(COP.x, COP.y, 5, 0, 2 * Math.PI, false);
    ctx.fillStyle = 'white';
    ctx.fill();
    ctx.lineWidth = 3;
    ctx.strokeStyle = '#003300';
    ctx.stroke();
  }

  centerOfPressure(points: { x: number, y: number, value: number }[]): { x: number, y: number } {

    let alreadyYCalculated: { y: number }[] = []
    let alreadyXCalculated: { x: number }[] = []

    let centerOfPressureX: { x: number }[] = []
    let centerOfPressureY: { y: number }[] = []


    points.map((point) => {
      //get the weight (x*value) of each value
      if (!alreadyYCalculated.find((yToFind) => yToFind.y === point.y)) {

        let filteredPointsSameY = points.filter((pointToFilter) => pointToFilter.y == point.y)
        let filteredPointsSameX = points.filter((pointToFilter) => pointToFilter.x == point.x)

        let totalWeightsPerX = 0;
        let totalWeightX = 0;

        filteredPointsSameY.map((pointY) => {
          totalWeightsPerX += pointY.x * pointY.value;
          totalWeightX += pointY.value;
        })

        let CopX = totalWeightsPerX / totalWeightX;
        centerOfPressureX.push({ x: CopX })

        alreadyYCalculated.push({ y: point.y })



        let totalWeightsPerY = 0;
        let totalWeightY = 0;

        filteredPointsSameX.map((pointX) => {
          totalWeightsPerY += pointX.y * pointX.value;
          totalWeightY += pointX.value;
        })

        let CopY = totalWeightsPerY / totalWeightY;
        centerOfPressureY.push({ y: CopY })

        alreadyXCalculated.push({ x: point.x })


      }

    })

    let sumOfX = 0;
    centerOfPressureX.map((COP) => {
      sumOfX += COP.x;
    })

    let sumOfY = 0;
    centerOfPressureY.map((COP) => {
      sumOfY += COP.y;
    })

    let copX = sumOfX / centerOfPressureX.length;
    let copY = sumOfY / centerOfPressureY.length;

    return {
      x: copX,
      y: copY
    }
  }


  showAllPoints() {

    var width = this.sizeOfPressure.width;
    var height = this.sizeOfPressure.height;

    var points: { x: number, y: number, value: number }[] = [];
    var newPoints = [];
    let max = 0;
    let maxYX: { x: number, y: number };

    let allPointsToCop: { x: number, y: number, value: number }[][] = []

    if (this.isStatic) {

      var record = this.jsonData.pressures;

      record.map((pressure) => {
        let weight = pressure.weight

        if (weight > max) {
          max = weight;
        }

        // check if already exists and it higher
        // let existsPoint = points.find((value) => value.x === (pressure.x * (width / this.platformNumberOfSensors)) && value.y === (pressure.y * (width / this.platformNumberOfSensors)));

        // if (!existsPoint) {
        points.push({
          x: pressure.x * (width / this.platformNumberOfSensors),
          y: pressure.y * (height / this.platformNumberOfSensors),
          value: weight
        })
        // }
      })

      // if (this.rotate180) {
      //   this.myCanvas.nativeElement.classList.add('rotate-180degrees')
      // }

    } else {

      // alinear puntos en el centro, mover X y Y
      this.centerPoints();

      this.jsonData.map((record: { time: number, pressures: { x: number, y: number, weight: number }[] }) => {

        let pointsToCOP: { x: number, y: number, value: number }[] = [];

        record.pressures.map((pressure) => {

          let weight = pressure.weight;
          let x = pressure.x * (width / this.platformNumberOfSensors);
          let y = pressure.y * (width / this.platformNumberOfSensors);

          if (weight > max) {
            max = weight;
            maxYX = { x, y };
          }

          // check if already exists and it higher
          let existsPoint = points.find((value) => value.x === x && value.y === y);
          if (existsPoint) {
            existsPoint.value += weight;
          } else {
            points.push({
              x,
              y,
              value: weight
            })

          }

          pointsToCOP.push({
            x,
            y,
            value: weight
          })

        })

        pointsToCOP = this.removeSinglePoints(pointsToCOP);

        allPointsToCop.push(pointsToCOP);

      })

      if (this.rotate180) {
        // this.myCanvas.nativeElement.classList.add('rotate-180degrees')
      }
    }


    // check the direction of the foot to rotate the image
    // if(this.jsonData[0].pressures[0].x < this.jsonData[this.jsonData.length - 1].pressures[0].x) {
    //   this.map.nativeElement.classList.add('rotate-90degrees-left')
    // } else {
    //   this.map.nativeElement.classList.add('rotate-90degrees-right')
    // }

    // remove alone points without other points arround
    points = this.removeSinglePoints(points);

    // Draw line
    const ctx = this.myCanvas.nativeElement.getContext('2d');

    points.map((point) => {
      if (point.x < this.minValues.x) {
        this.minValues.x = point.x;
      }

      if (point.y < this.minValues.y) {
        this.minValues.y = point.y;
      }

      if (point.value > max) {
        max = point.value;
        maxYX = { x: point.x, y: point.y }
      }

      newPoints.push([point.x, point.y, point.value])


    })

    // var data = {
    //   max: max,
    //   min: 0,
    //   data: points
    // };

    // this.heatmapInstance.setData(data);


    this.heat.data(newPoints)
    this.heat.radius(this.radius, this.blur)
    this.heat.max(max)
    this.heat.draw()

    // Show total value
    // points.map((point) => {
    //   if (point.x < this.minValues.x) {
    //     this.minValues.x = point.x;
    //   }

    //   if (point.y < this.minValues.y) {
    //     this.minValues.y = point.y;
    //   }
    //   ctx.font = "bold 10px Arial";
    //   ctx.globalAlpha = 1.0;
    //   ctx.fillText(point.value, point.x - 7, point.y + 5);

    // })



    // set line stroke and line width
    ctx.strokeStyle = 'red';
    ctx.lineWidth = 2;

    // draw a red line
    ctx.beginPath();
    // ctx.moveTo(point.x, point.y);
    // ctx.lineTo(point.x + 50, point.y);

    let lastXYLine: { x: number, y: number }

    allPointsToCop.map((pointToCOP, index) => {
      let COP = this.centerOfPressure(pointToCOP);
      // ctx.fillRect(COP.x, COP.y, 3, 3);
      ctx.globalAlpha = 1.0;
      // ctx.stroke();

      // Draw line
      if (lastXYLine) {
        ctx.beginPath();
        ctx.moveTo(lastXYLine.x, lastXYLine.y);
        ctx.lineTo(COP.x, COP.y);
        ctx.strokeStyle = '#000000';
        ctx.stroke();
      }

      lastXYLine = COP

    })
    ctx.closePath();

    if (allPointsToCop.length > 0) {
      let firstCOP = this.centerOfPressure(allPointsToCop[0])
      let lastCOP = this.centerOfPressure(allPointsToCop[allPointsToCop.length - 1])

      // if (firstCOP.y < lastCOP.y) {
      //   this.myCanvas.nativeElement.classList.add('rotate-180degrees')
      //   this.rotated = true;
      // }
    }


    // Draw maximum point of pressure
    // ctx.beginPath();
    // ctx.arc(maxYX.x, maxYX.y, 5, 0, 2 * Math.PI, false);
    // ctx.fillStyle = 'white';
    // ctx.fill();
    // ctx.lineWidth = 3;
    // ctx.strokeStyle = '#003300';
    // ctx.stroke();
  }


  // Player
  async play() {
    this.playing = true;
    this.changeDisableOptions();

    let timeout = 1000 / this.sliderFramesPerSecond.value;

    while (this.playing) {
      for (let record = this.sliderOption.value; record < this.jsonData.length; record++) {
        this.sliderOption.value = record;
        await this.wait(timeout);
        if (!this.playing) return;
      }

      // Reiniciar cuando llegue al final
      this.sliderOption.value = 0;
      await this.wait(100);
    }

    this.changeDisableOptions();
    this.showAllPoints();
  }


  pause() {
    this.playing = false;
    this.changeDisableOptions();
  }


  wait(ms) {
    return new Promise(resolve => {
      setTimeout(() => { resolve('') }, ms);
    })
  }

  exportPDF() {
    // Extraemos el
    const DATA = this.myCanvas.nativeElement;
    const doc = new jsPDF('p', 'pt', 'a4');
    const options = {
      background: 'white',
      scale: 3
    };
    html2canvas(DATA, options).then((canvas) => {

      const img = canvas.toDataURL('image/PNG');

      doc.addImage(img, 'PNG', -360, -250, 1360, 1360, undefined, 'FAST');

      return doc;

    }).then((docResult) => {
      docResult.save(`${this.orderData['Patient Data']['name']}_${this.orderData['Patient Data']['surname']}_${this.foot}.pdf`);
    });
  }
}
